import { useCallback } from 'react';
import notificationSound from '../assets/sounds/notification.mp3';

const audio = new Audio(notificationSound);

export const useSound = () => {
  const playNotification = useCallback(() => {
    audio.currentTime = 0;
    audio.play().catch(error => {
      console.error('Error playing sound:', error);
    });
  }, []);

  return { playNotification };
};
